import React from "react";
import {TicketActivityRecord, WorkLogEntry} from "../../../API/request/ticket.interface";
import {
    DynamikModal,
    IntlMessageValue,
    MIcon,
    UniButton,
    UniCol,
    UniForm,
    UniRow
} from "../../../../../@WUM/core/Elements";
import {
    ResponseNoteRecordtime,
} from "../../../API/response/ticketsystem2";
import {ApiRoot} from "../../../../../@WUM/core/RestFullApi/api";
import {ToastFn} from "../../../../worktimetracking/Pages/components/save/SubmitHandler";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {WorkLogCommentList} from "./WorkLogCommentList";

interface WorkLogCommentModalProps {
    entry: WorkLogEntry | null;
    show: boolean;
    onClose: () => void;
    showToast: ToastFn;
    Store: any;
    users?: responsibilityApiTYpe[];
}

export const WorkLogCommentModal = (props: WorkLogCommentModalProps): JSX.Element => {

    const {entry, show, onClose, showToast, Store, users} = props;

    const [validated, setValidated] = React.useState<boolean>(false);

    const [reload, setReload] = React.useState(false);

    const response = ResponseNoteRecordtime(
        String(entry?.ticketId),
        String(entry?.id),
        reload
    );

    const comments: TicketActivityRecord[] = Array.isArray(response)
        ? response
        : [];

    const send = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        setValidated(true);

        const form = event.currentTarget;

        if (!form.checkValidity()) {
            event.stopPropagation();
            return;
        }

        const formdata = new FormData(form);

        const raw = JSON.stringify({
            ticketId: entry?.ticketId,
            typeChildId: entry?.id,
            content: formdata.get("content"),
            public: formdata.get("public"),
        });

        const requestOptions: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization:
                    "Bearer " +
                    JSON.parse(localStorage.getItem("token") as string),
            },
            body: raw,
        };

        fetch(ApiRoot() + "ticket/yoptimize/note/save/3/", requestOptions)
            .then((response: Response) => response.json())
            .then((): void => {
                form.reset();
                setValidated(false);
                setReload(!reload);

                showToast({
                    func: "showToast",
                    type: "toast",
                    settings: ["variant", "success"],
                    content: "Kommentar wurde gespeichert.",
                    user: Store.user.id,
                });
            })
            .catch((error: unknown): void => {
                console.log(error);
            });
    };

    return (
        <DynamikModal
            title={"Detaillierter Kommentar"}
            size={"xl"}
            body={
                <div>
                    <div className="border rounded p-3 mb-3 bg-light">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <MIcon children={"article"} className={"d-flex fs-5"} />
                            <strong>Aktivitätsbericht</strong>
                        </div>

                        <div style={{whiteSpace: "pre-line"}}>
                            {entry?.activity_report?.content ?? "Kein Inhalt"}
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center gap-2">
                                <MIcon children={"comment"} className={"d-flex fs-5"} />
                                <strong>{IntlMessageValue("","common.comment",Store)}</strong>
                            </div>

                            <span className="badge bg-secondary">
                                {comments.length}
                            </span>
                        </div>

                        <WorkLogCommentList
                            comments={comments}
                            users={users}
                            currentUserId={Store.user.id}
                            Store={Store}
                        />
                    </div>

                    <hr />

                    <UniForm validated={validated} Submit={send} className={"mb-3"}>
                        <UniForm.FormGroup>
                            <UniForm.Label
                                text={IntlMessageValue("", "ticket.activity.new.comment", Store)}
                            />

                            <UniForm.FormControl
                                required
                                name={"content"}
                                type={"textarea"}
                                as="textarea"
                                rows={3}
                                defaultValue={""}
                            />
                        </UniForm.FormGroup>

                        <div className="form-check my-3">
                            <input
                                id="workLogCommentPublic"
                                name="public"
                                type="checkbox"
                                className="form-check-input"
                            />

                            <label
                                htmlFor="workLogCommentPublic"
                                className="form-check-label"
                            >
                                {IntlMessageValue("","ticket.public",Store)}
                            </label>
                        </div>

                        <UniRow>
                            <UniCol>
                                <UniButton
                                    type={"button"}
                                    onClick={(event: React.MouseEvent<HTMLButtonElement>): void => {
                                        const form = event.currentTarget.closest("form");

                                        form?.reset();
                                        setValidated(false);
                                    }}
                                    variant={"outline-secondary"}
                                >
                                    {IntlMessageValue("", "ticket.reset", Store)}
                                </UniButton>
                            </UniCol>

                            <UniCol>
                                <div className="d-flex justify-content-end">
                                    <UniButton
                                        type={"submit"}
                                        children={IntlMessageValue("", "common.submit", Store)}
                                        variant={"success"}
                                    />
                                </div>
                            </UniCol>
                        </UniRow>
                    </UniForm>
                </div>
            }
            openButtonLabel={null}
            saveButtonLabel={null}
            closeButtonLabel={"Schließen"}
            handlesubmit={(): void => undefined}
            handleShow={(): void => undefined}
            show={show}
            setShow={(): void => undefined}
            handleClose={onClose}
            hasNoForm={true}
            indiButton={true}
        />
    );
};